import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RMA_DEFAULT_HTTP_OPTIONS } from '@rma/dashboard/generic/util/environment';
import { Feature } from '@rma/dashboard/team/public/api-profile-members';
import { ProfileType } from '@rma/generic/domain/types';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserPermissionsApiService {
  private readonly http = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getPermissions(profileType: ProfileType, profileCode: string): Observable<Feature[]> {
    const url = this.rmaApiUrl(`${profileType}/${profileCode}/ProfilePermissions`);
    return this.http.get<Feature[]>(url, RMA_DEFAULT_HTTP_OPTIONS);
  }

  public getPermission(profileType: ProfileType, profileCode: string, featureName: Feature): Observable<Feature | null> {
    const url = this.rmaApiUrl(`${profileType}/${profileCode}/ProfilePermissions/${featureName}`);
    return this.http.get<Feature>(url, RMA_DEFAULT_HTTP_OPTIONS);
  }
}
